import { useSelector } from "react-redux"
import { Box, Stack, Typography, Button } from "@mui/material"
import editorScreenShot from "../../../assets/image/home/editor.png"
import kedyAICat from "../../../assets/image/home/kedy-ai-cat.svg"

const EditorShowcase = ({ handleCreateNewProject }) => {

    const languageStrs = useSelector((store) => store.editdata.languageStrs)

    return (
        <Stack alignItems={"center"} gap={1}>
            <Box display={"flex"} alignItems={"center"} gap={1} justifyContent={"center"}>
                <img width={"7%"} src={kedyAICat} />

                <Typography
                    variant="h3"
                    align="center"
                    sx={{
                        fontSize: { xs: '0.8rem', sm: '1.5rem', md: '2rem', lg: '3rem', xl: '3.5rem' },
                        fontWeight: 600,
                        marginBlock: '0.3rem',
                    }}
                >
                    {languageStrs.kedy_ai_editor}
                </Typography>
            </Box>

            <Box
                component={"img"}
                src={editorScreenShot}
                // width={{ xs: "80%", sm: '60%', md: '34%' }}
                width={"80%"}
                border={"1px solid #4b4b4b"}
                borderRadius={6}
            />

            <Typography align="center" sx={{
                fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
            }}>
                {languageStrs.kedy_offers_essential_video_editor_tools}
            </Typography>

            <Button
                className="upscaleTransition"
                onClick={handleCreateNewProject}
                sx={{
                    padding: '0 2rem',
                    borderRadius: 0,
                    flexDirection: 'column',
                    background: "linear-gradient(to right,#CD3235, #AA26BE)",
                    marginBottom: '1.5rem',
                }}
            >
                <Typography
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.5rem', md: '2rem', lg: '3rem', xl: '3.5rem' },
                        fontWeight: 700,
                        color: '#E0E0E0'
                    }}
                >
                    {languageStrs.create_project}
                </Typography>
            </Button>
        </Stack>
    )
}

export default EditorShowcase